module.exports = __webpack_public_path__ + "img/NotificationsActiveOutlined.1c528f6c.svg";